import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckBadge = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0.3636 0) scale(0.7273)",
		children: [/* @__PURE__ */ _jsx("rect", {
			y: .5,
			width: 32,
			height: 32,
			rx: 16,
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M22.6663 15.8853V16.4986C22.6655 17.9362 22.2 19.3351 21.3392 20.4865C20.4785 21.6379 19.2685 22.4803 17.8899 22.8879C16.5113 23.2955 15.0378 23.2465 13.6893 22.7483C12.3408 22.2501 11.1894 21.3293 10.407 20.1233C9.62452 18.9173 9.25287 17.4906 9.34746 16.0562C9.44205 14.6217 9.99781 13.2562 10.9319 12.1633C11.8659 11.0705 13.1282 10.3089 14.5305 9.99204C15.9327 9.67521 17.3999 9.82017 18.713 10.4053M22.6663 11.1653L15.9997 17.8386L13.9997 15.8386",
			stroke: "#fff",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})]
});
const ForwardRef = forwardRef(SvgCheckBadge);
export default ForwardRef;
